import React from "react";
import PropTypes from 'prop-types';

import { IconButton as NBIconButton } from "native-base"
import { Icon } from "./Icon";
import { extractNativeProps } from "../utils";

export class IconButton extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        ...Icon.propTypes
    }

    render() {
        const { onClick, onPress, ...otherProps } = this.props
        const [ uiProps, { icon, iconProps, pointerEvents, ...otherIconProps } ] = extractNativeProps(otherProps);


        return (
            <NBIconButton onPress={ onClick || onPress } pointerEvents={pointerEvents} { ...uiProps } icon={ <Icon colorScheme={uiProps.colorScheme} type={icon} { ...iconProps } { ...otherIconProps }  /> } /> 
        )
    }
}